export default class RangePromo {

    constructor(range, color, percent) {
        this.range = range
        this.color = color
        this.percent = percent
    }

    getTextDates(){
        // eslint-disable-next-line
        //console.log(this.range)
        let locale = window.navigator.language;
        let option = {
            month: "numeric",
            day: "numeric",
            year: "numeric"
        };
        
        if (this.percent != null && this.percent >0){
            let format = new Intl.DateTimeFormat(window.navigator.language, option);
            if (locale.toLowerCase().substring(0, 2) == "fr") {
                return (
                "du " +
                format.format(new Date(this.range.start)) +
                " au " +
                format.format(new Date(this.range.end))
                );
            } else {
                return (
                "from the " +
                format.format(new Date(this.range.start)) +
                " to the " +
                format.format(new Date(this.range.end))
                );
            }
        }else{
            return ''
        }
    }

    toTimeStamps(sec) {
        return {
            range: this.range.toTimeStamps(sec),
            color: this.color,
            percent: this.percent
        }
    }

    isContainedBy(months){
        let ret = false

        months.forEach(month => {
            if(this.range.start.getMonth() == month.getMonth() || this.range.end.getMonth() == month.getMonth()) ret = true
        })

        return ret
    }
}